import { mount } from "@vue/test-utils";
import TextInput from "@/components/core/TextInput";

describe("TextInput test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(TextInput, {
      props: {
        "v-mask": "'##/##/####'",
        hint: "DD/MM/YYYY",
        label: "Fecha de nacimiento",
        pattern: "[0-9]*",
        inputmode: "numeric",
        value: "value",
        required: "required",
        subhint: "subhint",
        validationError: "validationError"
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });
  it("Render del component DateField", () => {
    expect(wrapper).toBeDefined();
  });
});
